module.exports = __webpack_public_path__ + "_assets/img/volunteer-platform.fd805266.svg";